// extracted by mini-css-extract-plugin
export default {"boardPackage":"FaqDetail_boardPackage__+bGzC","contents":"FaqDetail_contents__cJmHC","boardList":"FaqDetail_boardList__W2wAu","DetailDetail":"FaqDetail_DetailDetail__aUMB4"};